import apiV2Service from 'common/src/modules/api/api-v2.service';
import {
  toClientAttributionSignal,
  toClientAttributionSignalStatistic,
} from './attributionSignals.dataConverters';
import {
  AttributionSignal,
  ServerAttributionSignal,
  AttributionSignalConditionOption,
  RemoteAttributionSignalStatistic,
  AttributionSignalStatistic,
} from './attributionSignals.types';
import _sortBy from 'lodash/sortBy';
import _map from 'lodash/map';

const BASE_PATH = 'AttributionSignals';

async function getAttributionSignals(): Promise<AttributionSignal[]> {
  const {data} = await apiV2Service.executeGetRequest<ServerAttributionSignal[]>(BASE_PATH);

  return _map(_sortBy(data, 'priority'), (attributionSignal, index) =>
    toClientAttributionSignal(attributionSignal, index),
  );
}

async function getAttributionSignalsStatistics(
  offset: number,
): Promise<AttributionSignalStatistic[]> {
  const {data} = await apiV2Service.executeGetRequest<RemoteAttributionSignalStatistic[]>(
    `${BASE_PATH}/Statistics`,
    {offset},
  );

  return _map(data, toClientAttributionSignalStatistic);
}

async function getAttributionSignalsConditionOptions(): Promise<
  AttributionSignalConditionOption[]
> {
  const {data} = await apiV2Service.executeGetRequest<AttributionSignalConditionOption[]>(
    `${BASE_PATH}/ConditionOptions`,
  );

  return data;
}

async function addAttributionSignal(data: Partial<ServerAttributionSignal>) {
  return apiV2Service.executePostRequest(BASE_PATH, {}, {...data});
}

async function editAttributionSignal(data: Partial<ServerAttributionSignal>) {
  return apiV2Service.executePutRequest<AttributionSignal[]>(
    `${BASE_PATH}/${data.id}`,
    {},
    {...data},
  );
}

async function deleteAttributionSignal(id: number) {
  return apiV2Service.executeDeleteRequest<AttributionSignal[]>(`${BASE_PATH}/${id}`);
}

async function updateAttributionSignalOrder(data: Record<string, number>) {
  return apiV2Service.executePutRequest(`${BASE_PATH}/UpdatePriorities`, {}, {...data});
}

export default {
  getAttributionSignals,
  addAttributionSignal,
  editAttributionSignal,
  deleteAttributionSignal,
  updateAttributionSignalOrder,
  getAttributionSignalsConditionOptions,
  getAttributionSignalsStatistics,
};
